export enum TeaserType {
	BASIC_AND_PLUS_TEASER = 'BasicAndPlus',
	UPGRADE_TEASER = 'Upgrade',
	PLUS_RENEW_TEASER = 'Renewal',
	PLUS_EXPIRY_TEASER = 'Expiry',
	NO_CONTENT = 'NoContent',
	ACHIEVEMENT_TEASER = 'Achievement',
	TO_LOGIN = 'UnidentifiedUser',
	TO_UP_HOME = 'UpHomeLink',
	BOOSTER_TEASER = 'UpgradeBooster',
	NON_UP_PLUS_BOOSTER_TEASER = 'NonUpPlusBooster'
}

export const isValidTeaserType = (value: string): boolean => {
	return Object.values(TeaserType).includes(value as TeaserType);
}

export const hasAnOttoUpPackage = (teaserType: TeaserType): boolean => {
	return teaserType !== TeaserType.BASIC_AND_PLUS_TEASER;
};

export const hasBasic = (teaserType: TeaserType): boolean => {
	return teaserType === TeaserType.UPGRADE_TEASER || teaserType === TeaserType.PLUS_RENEW_TEASER || teaserType == TeaserType.BOOSTER_TEASER;
};

export const hasPlus = (teaserType: TeaserType): boolean => {
	return teaserType === TeaserType.PLUS_EXPIRY_TEASER;
};
